// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = theme => ({
  menuContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  menuRight: {
    marginLeft: 40,
    [theme.breakpoints.down(500)]: {
      marginLeft: 10,
    },
    [theme.breakpoints.down(400)]: {
      marginLeft: 0,
    },
  },
  menuTextRight: {
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    [theme.breakpoints.down(1200)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
  },
  linkContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '10px 5px',
    padding: 5,
  },
  flexDirectionColumn: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  link: {
    display: 'flex',
    textDecoration: 'none',
    color: GlobalStyles.color.COLOR_GREY,
    '&:hover': {
      textDecoration: 'none',
      color: GlobalStyles.color.COLOR_GREY,
    },
  },
  menuIconLink: {
    cursor: 'pointer',
  }
});

export default styles;
